"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.read = void 0;
var solid_ui_1 = require("solid-ui");
var attribution_1 = require("./attribution");
function read(subject, store) {
    var content = store.any(subject, solid_ui_1.ns.as("content"));
    var published = store.any(subject, solid_ui_1.ns.as("published"));
    var attributedTo = (0, attribution_1.readAttribution)(subject, store);
    if (!content) {
        return null;
    }
    return {
        content: content.value,
        published: published && new Date(published.value),
        attributedTo: attributedTo,
    };
}
exports.read = read;
//# sourceMappingURL=note.js.map